import React, { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import useManageSubjects from 'hooks/API/useManageSubjects';
import useSubjects from 'hooks/API/GET/useSubjects';
import useToaster from 'hooks/useToaster';
import * as AppPics from 'assets/images';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import ManageSubjects from './ManageSubjects';

/**
 * ManageSubjectPage
 * Standardized page for adding or updating a Subject.
 */
function ManageSubjectPage() {
  const { subjectID } = useParams();
  const history = useHistory();
  const editMode = !!subjectID && subjectID !== 'add';

  const { isLoading: postingSubjects, mutate, isError: postingError } = useManageSubjects();

  // Fetch existing Subject data if in edit mode
  const { data: subjectData, isLoading: subjectFetching } = useSubjects({
    enabled: editMode,
    configs: { params: { id: subjectID } },
  });

  useToaster(postingSubjects, { type: postingError ? 'error' : 'success' });

  const handleGoBack = () => {
    history.goBack();
  };

  const handleSave = (formData) => {
    if (postingSubjects) return;

    mutate(formData, {
      onSuccess: () => {
        setTimeout(() => {
          history.push('/manage/subjects');
        }, 1000);
      },
    });
  };

  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back" onClick={handleGoBack}>
              <img src={AppPics.BackSvg} alt="Back" />
            </button>
          </li>
        </ul>

        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs
              links={[
                { label: 'Dashboard', to: '/dashboard' },
                { label: 'Curriculum', to: '/curriculum' },
                { label: 'Subjects', to: '/manage/subjects' },
              ]}
              current={editMode ? 'Update Subject' : 'Add Subject'}
            />
          </div>

          <div className="tab__content-actBody">
            <div className="px-5 py-5">
              {subjectFetching ? (
                <div className="text-center p-5">Loading subject data...</div>
              ) : (
                <ManageSubjects
                  save={handleSave}
                  selectedItem={subjectData?.data?.result?.[0] || {}}
                  handleSelectedItem={() => {}}
                  isPageMode={true}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageSubjectPage;
